import React from 'react'
import { Col, ProgressBar, Row } from 'react-bootstrap'
import styles from './AnalyticsPdfPageDetails.module.css'

const ANALYTICS_PDF_PAGE_COLUMNS = [
  { key: 'page', label: 'Page:', value: (page) => `Page ${page.page}`, weight: true },
  { key: 'pageviews', label: 'Views:', value: (page) => page.pageviews },
  { key: 'visitors', label: 'Unique:', value: (page) => page.visitors },
  { key: 'avgTime', label: 'Time:', value: (page) => `${page.avgTime}s` },
  { key: 'bounceRate', label: 'Bounce:', value: (page) => `${page.bounceRate}%` }
]

const AnalyticsPdfPageRow = ({ page }) => (
  <Row className={`${styles.pageRow} py-3 border-bottom g-0`}>
    {ANALYTICS_PDF_PAGE_COLUMNS.map(({ key, label, value, weight }) => (
      <Col key={key} xs={6} lg={2} className="mb-2 mb-lg-0">
        <span className="d-inline d-lg-none text-muted me-2">{label}</span>
        <span className={weight ? 'fw-medium' : ''}>{value(page)}</span>
      </Col>
    ))}

    <Col xs={6} lg={2}>
      <span className="d-inline d-lg-none text-muted me-2">Engagement:</span>
      <div className="d-flex align-items-center">
        <ProgressBar
          now={page.engagement}
          className={styles.engagementBar}
          variant={page.engagement > 70 ? 'success' : page.engagement > 40 ? 'warning' : 'danger'}
        />
        <span className="ms-2 small">{page.engagement}%</span>
      </div>
    </Col>
  </Row>
)

export default AnalyticsPdfPageRow
